<template>
  <div class="participants py-2" v-if="size(participants)">
    <div class="font-weight-bold mb-1">
      {{ participantsType | capitalize }}
    </div>
    <div class="d-flex flex-wrap">
      <div
        :key="index"
        v-for="(participant, index) in participants"
        :class="{ 'flex-grow-1': size(participant.comments) }"
      >
        <v-chip class="selected-worker-chip mr-2">
          <v-icon>mdi-account</v-icon> {{ participant.user | fullName }}
          <v-icon
            class="participant-icon"
            :class="getInterviewParticipantIconClass(participant)"
            v-if="getInterviewParticipantStatusIcon(participant)"
          >
            {{ getInterviewParticipantStatusIcon(participant) }}
          </v-icon>
        </v-chip>
        <div class="participant-comment" v-if="size(participant.comments)">
          <v-icon color="primary" class="d-flex align-start mr-2">
            mdi-information
          </v-icon>

          <div class="d-flex flex-column">
            <p class="mb-2">
              <strong>{{ getCommentTitle(participant) }}</strong>
              ({{ last(participant.comments).createdAt | longDatewithTime }})
            </p>
            <p class="font-italic mb-1">
              {{ last(participant.comments).body }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { size, last, capitalize } from "lodash";

export default {
  props: {
    participants: {
      type: Array
    },
    participantsType: {
      type: String,
      required: true
    }
  },
  methods: {
    getInterviewParticipantIconClass(participant) {
      return participant.participantRsvpStatus;
    },
    getInterviewParticipantStatusIcon(participant) {
      switch (participant.participantRsvpStatus) {
        case "accepted":
          return "mdi-check";
        case "reschedule":
          return "mdi-sync";
        case "tentative":
          return "mdi-help";
        case "declined":
          return "mdi-window-close";
      }
    },
    getCommentTitle({ participantType, participantRsvpStatus }) {
      const participant = capitalize(participantType);
      switch (participantRsvpStatus) {
        case "accepted":
          return `${participant} has requested an adjustment`;
        case "reschedule":
          return `${participant} has requested a reschedule`;
        case "declined":
          return `${participant} has cancelled this interview`;
        default:
          return "";
      }
    },
    size,
    last
  }
};
</script>

<style lang="scss">
.participants {
  .participant-icon {
    font-size: 20px;
    color: $white;
    margin-left: 5px;
    border-radius: 4px;
    width: 25px;
    height: 25px;

    &.accepted {
      background-color: #17d99b;
    }
    &.tentative {
      background-color: $default-line;
    }
    &.declined {
      background-color: #ea0b40;
    }
    &.reschedule {
      background-color: #ffb800;
    }
  }

  .participant-comment {
    display: flex;
    margin: 10px 0;
    background-color: rgba($_yellow, 0.15);
    border-radius: 4px;
    padding: 10px;
  }
}
</style>
